import { useEffect, useState } from "react";
import {
  makeAjax,
  url,
  showMessage,
  respStatus,
} from "../../helpers/global_helper";
import { formatPrice } from "../NumberFormat";
import { withTranslation } from "react-i18next";

const Bonus = (props) => {
  const [bonus, setBonus] = useState("");
  const [bonusName, setBonusName] = useState("");
  const [showBonusPopup, setShowBonusPopup] = useState(false);
  const [date, setDate] = useState("");

  const fetchBonus = () => {
    let reqData = {};
    makeAjax(
      url.PLAYER_API.getUserEventBonusCoin,
      reqData,
      url.PLAYER_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          showMessage("Server error: No data found", "error", "error");
          return;
        }
        showMessage("Server error: No data found", "error", "error");
        return;
      }

      setBonus(response.data.value);
      setBonusName(response.data.name);
      setDate(response.data.date);

      if (response.data.value) {
        setShowBonusPopup(true);
      } else {
        setShowBonusPopup(false);
      }
    });
  };

  useEffect(() => {
    fetchBonus();
  }, []);

  return (
    <>
      {showBonusPopup && (
        <div className="bonus-error">
          <div className="bonus-error-popup">
            <p className="heading">{props.t("message")}</p>
            <span className="bonus-close" onClick={() => setShowBonusPopup(false)}>x</span>
            <p className="error-message">
              {props.t('txt_event_manual_popup_1', { defaultValue: "Congratulations!. You’re chosen to get bonus of IDR" })} : {formatPrice(bonus)}</p>
              <p className="promo-txt">{props.t('date', { defaultValue: "Date" })} : {date}</p>
            <p className="promo-txt">{props.t('txt_event_manual_popup_2', { defaultValue: "Promotion" })} : {bonusName}</p>
            <p className="bonus-btm">{props.t('txt_event_manual_popup_3', { defaultValue: "For further information please see in the Promotion Menu." })}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default withTranslation()(Bonus);
